interface TerminalLineProps {
  command: string
  output: string
  accent?: boolean
}

export function TerminalLine({ command, output, accent = false }: TerminalLineProps) {
  return (
    <div className="space-y-3">
      <div className="flex gap-3">
        <span className="text-primary/70">$</span>
        <span>{command}</span>
      </div>
      <div className={accent ? 'terminal-glow pl-6 text-center text-primary' : 'pl-6 text-center text-muted'}>
        {output}
      </div>
    </div>
  )
}
